// -----------------------------------------------------------------------
// Editorial photo set - refonte 2026 (inspiration Citwell).
// Curated for the new cream/dark alternating layout. Images cropped
// vertically to serve as hero visuals (4/5 or 5/6) and card overlays.
// -----------------------------------------------------------------------

const UNS = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export const EDITORIAL_PHOTOS = {
  // Hero · corporate home - strategy / decision room (people around a plan)
  heroHome:          UNS("1552664730-d307ca884978"),
  // Supply chain planning room / APS planning console
  heroCapabilities:  UNS("1551288049-bebda4e38f71"),
  // Boutique working atmosphere - About
  heroAbout:         UNS("1521737711867-e3b97375f902"),
  // Clients - professional handshake / partnership
  heroClients:       UNS("1600880292203-757bb62b4baf"),
  // Partners - collaboration network
  heroPartners:      UNS("1521737604893-d14cc237f11d"),
  // Contact - modern workspace
  heroContact:       UNS("1517694712202-14dd9538aa97"),

  // Signal / spotlight tiles - used in "Êtes-vous prêt ?" style blocks
  spotIa:            UNS("1620712943543-bcc4688e7485"),  // AI neural
  spotGovernance:    UNS("1507003211169-0a1dd7228f2d"),  // oversight / people
  spotDashboard:     UNS("1551288049-bebda4e38f71"),      // dashboard
  spotNetwork:       UNS("1518770660439-4636190af475"),   // network / circuit
  spotFactory:       UNS("1565793298595-6a879b1d9492"),   // factory floor
  spotWarehouse:     UNS("1586528116311-ad8dd3c8310d"),   // warehouse
  spotStrategy:      UNS("1552664730-d307ca884978"),      // strategy room
  spotData:          UNS("1639322537228-f710d846310a"),   // abstract data
};
